<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: MCR
 * @Date: 2020-07-11 10:06:22
 * @LastEditors: MCR
 * @LastEditTime: 2020-07-11 10:06:22
 -->
<!--  -->
<template>
  <div class="PrivateTopicManage">
    <easyCruds
      ref="mainTable"
      :data="data"
      :tableInfo="conf.mainTable"
      @mainTableReload="mainTableReload"
      @deleteRows="deleteRows"
      @saveRowByAddOrEdit="saveRowByAddOrEdit"
      @beforeAddViewEdit="beforeAddViewEdit"
    >
    </easyCruds>
  </div>
</template>

<script>

export default {
  data() {
    const mainTable = {
      header: { title: '数据源管理' },
      buttonSetting: {
        allowAdd: true,
        addText: '新增数据源',
        addCloseOnClickModal: true,
        beforeAddFunctionName: 'beforeAddViewEdit',
        addButtonArray: [{
          clickEvent: 'saveRowByAddOrEdit',
          type: 'primary',
          buttonName: '新增',
          validate: true
        }
        ],
        allowEdit: true,
        editText: '编辑数据源',
        editCloseOnClickModal: true,
        editButtonArray: [{
          clickEvent: 'saveRowByAddOrEdit',
          type: 'primary',
          buttonName: '保存编辑',
          validate: true
        }],
        beforeEditFunctionName: 'beforeAddViewEdit',
        allowDelete: true,
        deleteFunctionName: 'deleteRows',
        allowView: true,
        allowMoreDelete: false,
        viewText: '查看数据源',
        viewCloseOnClickModal: true,
        beforeViewFunctionName: 'beforeAddViewEdit',
        left: [],
        right: []
      },
      table: {
        loading: false,
        height: 550,
        stripe: true,
        conditionLabelWidth: 'auto',
        index: true,
        selection: false,
        columns: [{
          prop: 'dbCode',
          label: '数据源名称',
          isSearchCondition: true,
          sortable: true,
          type: 'input',
          width: 150,
          maxlength: 500,
          required: true
        }, {
          prop: 'dbName',
          label: '数据库名称',
          isSearchCondition: true,
          type: 'input',
          width: 160,
          maxlength: 500,
          required: true
        }, {
          prop: 'dbIp',
          label: 'IP地址',
          isSearchCondition: true,
          type: 'input',
          width: 140,
          maxlength: 500,
          required: true
        }, {
          prop: 'dbPort',
          label: '端口号',
          isSearchCondition: true,
          type: 'input',
          width: 100,
          maxlength: 500,
          required: true
        }, {
          prop: 'dbType',
          label: '数据库类型',
          isTag: true,
          width: 120,
          maxlength: 500,
          type: 'select',
          isSearchCondition: true,
          required: true,
          tagFilter: function(e) {
            if (e === 'mysql') {
              return { data: 'mysql' }
            } else if (e === 'oracle') {
              return { data: 'oracle' }
            } else if (e === 'sqlserver') {
              return { data: 'sqlserver' }
            } else {
              return { data: '其他' }
            }
          },
          dicData: [{
            'label': 'mysql',
            'value': 'mysql'
          }, {
            'label': 'oracle',
            'value': 'oracle'
          }]
        }, {
          prop: 'status',
          label: '状态',
          width: '100',
          isTag: true,
          type: 'select',
          isSearchCondition: true,
          required: true,
          tagFilter: function(e) {
            if (e === 1) {
              return { data: '可用', type: 'success' }
            } else {
              return { data: '不可用', type: 'warning' }
            }
          },
          dicData: [{
            'label': '可用',
            'value': 1
          }, {
            'label': '不可用',
            'value': 2
          }]
        }, {
          prop: 'userName',
          label: '用户名',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: true
        }, {
          prop: 'passWord',
          label: '密码',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: true
        }, {
          prop: 'initialSize',
          label: '初始连接数',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: false
        }, {
          prop: 'maxActive',
          label: '最大连接数',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: false
        }, {
          prop: 'minIdle',
          label: '最小连接数',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: false
        }, {
          prop: 'maxWait',
          label: '最长等待时间',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: false
        }, {
          prop: 'timeBetweenEvictionRunsMillis',
          label: '检测连接间隔',
          isSearchCondition: false,
          slot: false,
          type: 'input',
          maxlength: 500,
          required: false
        }, {
          label: '连接申请检测',
          prop: 'testOnBorrow',
          search: false,
          sortable: false,
          width: 100,
          type: 'select',
          slot: true,
          dicData: [{
            label: '开启',
            value: 'true'
          }, {
            label: '关闭',
            value: 'false'
          }]
        }, {
          label: '连接归还检测',
          prop: 'testOnReturn',
          search: false,
          sortable: false,
          width: 100,
          type: 'select',
          slot: true,
          dicData: [{
            label: '开启',
            value: 'true'
          }, {
            label: '关闭',
            value: 'false'
          }]
        }, {
          label: '连接空闲检测',
          prop: 'testWhileIdle',
          search: false,
          sortable: false,
          width: 100,
          type: 'select',
          slot: true,
          dicData: [{
            label: '开启',
            value: 'true'
          }, {
            label: '关闭',
            value: 'false'
          }]
        }, {
          label: '是否开启缓存',
          prop: 'poolPreparedStatements',
          search: false,
          sortable: false,
          width: 100,
          type: 'select',
          slot: true,
          dicData: [{
            label: '开启',
            value: 'true'
          }, {
            label: '关闭',
            value: 'false'
          }]
        }, {
          label: '是否异步处理',
          prop: 'asyncInit',
          search: false,
          sortable: false,
          width: 100,
          type: 'select',
          slot: true,
          dicData: [{
            label: '开启',
            value: 'true'
          }, {
            label: '关闭',
            value: 'false'
          }]
        }],
        operation: {
          width: '220',
          operations: []
        },
        tableData: [],
        paging: {
          currentPage: 1,
          pageSizes: [15, 20, 25, 30],
          pageSize: 15,
          total: 0
        },
        reload: 'mainTableReload',
        reloadConditions: {},
        addDefultValue: {}
      }
    }
    return { /** 控制扩展字段表,插入的插槽位置 */
      extTable: {
        data: [],
        allowModify: false
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      query: {},
      currentAppKey: '',
      conf: { mainTable }
    }
  },
  components: {},
  mounted: function() {
    this.$nextTick(() => {
      this.getSelectOPtion()
    })
  },
  methods: {
    /** 获取数据源 */
    getSelectOPtion: function() {
      this.conf.mainTable.table.loading = true
      this.$http.post('/fighter-workflow-saas/multiple-database/query', { 'entity': this.query }, { params: {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }}).then(
        response => {
          this.conf.mainTable.table.loading = false
          this.conf.mainTable.table.tableData = response.data.records
          this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
          this.selectionClear()
        }
      ).catch(
        error => {
          this.conf.mainTable.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    /** 根据条件搜索数据源 */
    mainTableReload: function(params) {
      this.conf.mainTable.table.loading = true
      this.$http.post('/fighter-workflow-saas/multiple-database/query', {
        'entity': {
          'dbCode': params.dbCode,
          'dbName': params.dbName,
          'dbIp': params.dbIp,
          'dbPort': params.dbPort,
          'dbType': params.dbType,
          'status': params.status
        }
      }, {
        params: {
          pageNum: params.pageNum || 1,
          pageSize: params.pageSize || 15
        }
      }).then(response => {
        this.conf.mainTable.table.loading = false
        /** Successful Business logic */
        this.conf.mainTable.table.tableData = response.data.records
        this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
      }).catch(error => {
        /** Network error or [.then] code block throw exception */
        this.conf.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    },
    /** Delete data */
    deleteRows: function(deleteList) {
      this.conf.mainTable.table.loading = true
      this.$http.delete(`/fighter-workflow-saas/multiple-database/` + deleteList[0].id
      ).then(response => {
        this.conf.mainTable.table.loading = false
        this.$message.success('删除数据源成功！')
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.conf.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    },
    beforeAddViewEdit: function(row, optionType, callback) {
      if (optionType === 'ADD') {
        this.setExtTable([], 'ADD') && callback()
      } else {
        this.conf.mainTable.table.loading = true
        /** Control expanded field dataTables add, delete button state */
        this.$http.get('/fighter-workflow-saas/multiple-database/' + row.id).then(response => {
          this.conf.mainTable.table.loading = false
          this.setExtTable(response.data.subjectExtList, optionType) && callback()
        }).catch(error => {
          this.conf.mainTable.table.loading = false
          return this.$message.error(error.msg)
        })
      }
    },
    saveRowByAddOrEdit: function(params, done, errDone, method) {
      this.$http[method === 'EDIT' ? 'put' : 'post']('/fighter-workflow-saas/multiple-database', params).then(response => {
        this.$message.success('操作成功！') && done()
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.$message.error(error.msg) && errDone()
      })
    }, /**
     * 设置扩展字段插槽名称,并控制按钮
     */
    setExtTable: function name(data = [], type) {
      this.extTable.data.splice(0, this.extTable.data.length)
      data.forEach(item => this.extTable.data.push(item))
      if (type === 'VIEW') {
        this.extTable.allowModify = false
      } else {
        this.extTable.allowModify = true
      }

      return true
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
